import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./TemplateFooter3.module.css";
import { FaPhone, FaEnvelope } from "react-icons/fa";
import { useAuth } from "../../Common/Configurations/AuthContext";

const TemplateFooter3 = ({
  branding,
  footerData,
  headerMenu=[],
  onNavigate,
  mode,
  templateId
}) => {

  const { user } = useAuth();
  const navigate = useNavigate();

  const brandName =
    branding?.brandName ||
    user?.brandName ||
    "Travel Agency";

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const aboutText =
    footerData?.aboutText ||
    "Luxury travel experiences crafted for explorers.";

  const handleNavClick = (e,item)=>{
    const viewName=item.path==="/"
      ?"home"
      :item.path.replace("/","");

    if(mode==="builder"){
      e.preventDefault();
      onNavigate({name:viewName,params:null});
    }
    else if(mode==="preview"){
      e.preventDefault();
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
  };

  return(
    <footer className={styles.footer}>

      <div className={styles.top}>
        <h2 className={styles.brand}>{brandName}</h2>
        <p className={styles.about}>{aboutText}</p>
      </div>

      <div className={styles.links}>

        {headerMenu.map(item=>(
          <Link
            key={item.id}
            to={item.path}
            onClick={(e)=>handleNavClick(e,item)}
          >
            {item.label}
          </Link>
        ))}

      </div>

      <div className={styles.contactRow}>
        <div><FaPhone/> {phone}</div>
        <div><FaEnvelope/> {email}</div>
      </div>

      <div className={styles.bottom}>
        © {new Date().getFullYear()} {brandName}
      </div>

    </footer>
  )
}

export default TemplateFooter3